import { getAuthToken } from 'storage'

export const isLoggedIn = () => {
  const token = getAuthToken()
  return token?.length > 0 || false
}
